import { useContext, useEffect, useState } from 'react';
import { WebsocketEmitters } from '@common/app/socket';
import { socket } from '@common/socket/socket';
import { type LevelUpSocketEventType } from '@common/types/socket';
import { IntroContext } from '@components/Intro/context.ts';
import { ModalContext } from '@components/Modals/Modal/config';
import { useAppSelector } from '@redux/store';

import { useLazyExtendedInfoQuery } from '@/api/queries/user';

import { entriesToSingleFieldObjArray } from '../lib/array';
import { Playdeck } from '../lib/playdeck';

import { useSelectorRef } from './selector-ref';

const useUserLevelUpListener = (): void => {
  const isFirstVisit = useAppSelector((state) => state.user.isFirstVisit);
  const [getExtendedInfo] = useLazyExtendedInfoQuery();
  const { openModal, isOpen, modalContent } = useContext(ModalContext);
  const { isIntroActive } = useContext(IntroContext);
  const [levelUpReward, setLevelUpReward] =
    useState<LevelUpSocketEventType | null>(null);

  const capitalization = useSelectorRef(
    (state) => state.user.extendedInfo?.totalEmpireValue,
  );

  useEffect(() => {
    const onLevelUpCallback = (data: LevelUpSocketEventType): void => {
      console.log('level up!');
      getExtendedInfo();
      setLevelUpReward(data);
      Playdeck.sendAnalitics({
        type: 'custom_event',
        name: 'level_up',
        user_properties: {},
        event_properties: {
          level: data.upgrade,
          capitalizations: capitalization || 0,
          reward: Object.entries(data).map(entriesToSingleFieldObjArray),
        },
      });
    };

    socket.on(WebsocketEmitters.LEVEL_UPGRADE, onLevelUpCallback);

    return (): void => {
      socket.off(WebsocketEmitters.LEVEL_UPGRADE, onLevelUpCallback);
    };
  }, []);

  useEffect(() => {
    if (levelUpReward && !isOpen && !isFirstVisit && !isIntroActive) {
      openModal({ renderKind: 'userLevelUp', props: levelUpReward });
      setLevelUpReward(null);
    }
  }, [levelUpReward, modalContent, isOpen, openModal]);
};

export { useUserLevelUpListener };
